import { User } from "../types/api/User";

export const purchasingRedirect = (user: User) => {
  // console.log("purchasingRedirect", user);
  if (!user.purchasing_organizations) {
    return "/404";
  }
  if (user.purchasing_organizations.length === 0) {
    return "/404";
  }
  if (user.purchasing_organizations.length === 1) {
    return `/storefront/${user.purchasing_organizations[0].organization.id}`;
  }
  return `/storefront/all`;
};
